function getUrlParameter(param) {
  var pageUrl = window.location.search.substring(1);
  var params = pageUrl.split('&');

  for (var i = 0; i < params.length; i++) {
    var parameterName = params[i].split('=');
    if (parameterName[0] === param) { return parameterName[1]; }
  }
}

var createUrl = function (base, paths, params) {
  if (arguments.length === 0) throw new Error('Base url or path is required.');

  var _url = base;
  var _paths = paths || [];
  var _params = params || {};

  for (key in _paths) {
    if (!!key) {
      var separator = _url.slice(-1) !== "/" ? "/" : "";
      _url += separator + _paths[key]
    }
  }

  for (key in _params) {
    if (!!_params[key]) {
      var separator = _url.indexOf('?') !== -1 ? "&" : "?";
      _url += separator + key + "=" + _params[key];
    }
  }

  return _url
}

// Util
function toMoney(value) {
  var amount = Number(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return '$' + amount;
}

function toFloat(value, precision = 2) {
  return parseFloat(value).toFixed(precision);
}

function toNumber(value) {
  return Number(String(value).replace(/[$,]+/g, ""));
}

function serializeObject(form) {
  var _object = {};
  var _array = form.serializeArray();

  $.each(_array, function () {
    if (_object[this.name]) {
      if (!_object[this.name].push && _object[this.name] !== "0") {
        _object[this.name] = [_object[this.name]];
      }
      if (Array.isArray(_object[this.name])) {
        _object[this.name].push(this.value || "");
      } else {
        _object[this.name] = this.value || "";
      }
    } else {
      _object[this.name] = this.value || "";
    }
  });

  return _object
}

$(function () {
  renderMarkdown($('#payment-explanation'), $.polyglot.t('payment_explanation', $.interpolations));
});
var espSettings = {
  autoPromotion: $("#promotion-form").data("autoPromotion") || false,
  autoPromotionCode: _.get($.siteConfiguration, "enable_auto_promotion_options.auto_promotion", ""),
  autoShippingPromotion: $("#promotion-form").data("autoShippingPromotion") || false,
  autoShippingPromotionCode: _.get($.siteConfiguration, "enable_auto_promotion_options.auto_shipping_promotion", ""),
  shippingMethod: $("#shipping-form").data("shippingMethod") || "FEDEX_GROUND"
}

$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    actionStart();
  }
});

function isShippingMethodsSet() {
  var methodSpan = $('#shipping-form .method-text-start');
  if(methodSpan.length > 0) { return true; }
}

function isFuji() {
  var currentDomain = window.location.hostname.toLowerCase();
  return currentDomain.includes('fujifilm');
}

function shippingMethodsSelectOn() {
  $('.shipping-method-section .radio-group input[type="radio"]:first').prop('checked', true);
}

function shippingMethodSet() {
  var id = parseFloat($('input[name="order[shipping_method_id]"]').val());
  if ($('input[name="order[shipping_method_id]"]').is(':checked')) {
    id = parseFloat($('input[name="order[shipping_method_id]"]:checked').val());
  }
  var url = '/server_side_carts/update_shipping_method/' + id;
  return $.ajax({
    url: url,
    type: 'PUT',
    dataType: 'json',
    success: function (data) {
      window.shoppingCart = data;
    }
  });
}

$(document).ready(function() {
  if (isShippingMethodsSet()) {
    shippingMethodSet();
    shippingMethodsSelectOn();
  }
});

$('.shipping_method').on('change', function() {
  if ($(this).is(':checked') && !isFuji()) {
    shippingMethodSet();
    init();
  }
});

function shippingMethodsUpdate() {
  if (isFuji()) { return; }

  var deferred = $.Deferred();
  var id = parseFloat($('input[name="order[shipping_method_id]"]').val());
  if ($('input[name="order[shipping_method_id]"]').is(':checked')) {
    id = parseFloat($('input[name="order[shipping_method_id]"]:checked').val());
  }

  var url = '/server_side_carts/update_shipping_method/' + id;

  $.ajax({
    url: url,
    type: 'PUT',
    dataType: 'json',
    success: function (data) {
      //window.shoppingCart = $.extend(true, window.shoppingCart, data);
      window.shoppingCart = data;
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  });
  return deferred.promise();
}


function calculateTax() {
  var deferred = $.Deferred();

  if ($.siteConfiguration.site_name === "DirectBuy" && !_.includes(["Kansas", "Kentucky"], $("#billing_state").val())) {
    $("#tax").html(toMoney(0));
    $("#total, #m-total").html(window.shoppingCart.cart_sub_total);
    $(".loading-overlay").css("opacity", "0");
    deferred.resolve();
    return deferred.promise();
  }

  RegistriaShoppingCart.calculateTax({
    success: function (data) {
      var _tax = data.cart_tax;
      var _total = data.cart_total;
      var _discountTotal = data.cart_discount_total;
      var _shippingTotal = data.cart_shipping_and_handling_total;
      var _discount = data.cart_coupon_discount_total;
      var _retail = parseFloat(data.cart_retail_delivery_fee.replace("$", "")).toFixed(2);

      window.shoppingCart.cart_coupon_discount_total = _discount;
      window.shoppingCart.cart_tax = _tax;
      window.shoppingCart.cart_total = _total;

      if (isNaN(toNumber(data.cart_tax))) {
        $("#discount").html(_discountTotal);
        taxErrorMessage();
        $("#tax").addClass('invalid');
        $("#total, #m-total").html(_total);
        $(".submitPayment").prop("disabled", true);
      } else {
        $("#discount").html(_discountTotal);
        $("#tax").html(_tax);
        $("#tax").removeClass('invalid');

        $("#total, #m-total").html(_total);
        $(".submitPayment").prop("disabled", false);
      }
      deferred.resolve(data);
    },
    error: function(error) {
      taxErrorMessage();
      $("#tax").addClass('invalid');
      $(".submitPayment").prop("disabled", true);
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function update_shipping_amounts(promotion_type) {
  switch (promotion_type) {
    case "free_shipping":
    case "grouped_coupon":
      $("#shipping-form input.shipping_method").each(function () {
        $(this).data('shippingPrice', "0.0")
        $(this).siblings("label").find(".shipping_price").html(toMoney(0))
      })
      break;
    default:
      break;
  }
}

function calculateShipping() {

  if (!isShippingMethodsSet()) {
    if (shippingErrorMessage.call($(this))) { return }
  }

  var _shipping_rate = $(this).data("shippingPrice") ? Number($(this).data("shippingPrice")) : 0 ;
  var _shipping_rate_money = toMoney(_shipping_rate);
  var _subtotal = toNumber(window.shoppingCart.cart_sub_total);
  var _discount = toNumber(window.shoppingCart.cart_coupon_discount_total === "-" ? "$0.00" : window.shoppingCart.cart_coupon_discount_total);
  var _tax = toNumber(window.shoppingCart.cart_tax);
  var _shippingTotal = window.shoppingCart.cart_shipping_and_handling_total;
  var _total = _subtotal - _discount + _tax + _shipping_rate;
  var _total_money = toMoney(_total);
  var _total_money_amount = toMoney(_total);
  var _cart_shipping = window.shoppingCart.cart_shipping_total;
  var _cart_shipping_handling = window.shoppingCart.cart_shipping_and_handling_total;

  window.shoppingCart.cart_shipping_total = _shipping_rate_money;
  window.shoppingCart.cart_total = _total_money;
  var display_shipping_rate_money = _shipping_rate === 0 ? "FREE" : _shipping_rate_money
  $('#shipping').html(display_shipping_rate_money);
  if (isShippingMethodsSet() && !isFuji()) {
    $('#shipping').html(_cart_shipping);
    if(_cart_shipping == '$0.00') {
      $('#shipping').html(_cart_shipping_handling);
    }
    _total_money_amount = toMoney(toNumber(_total) + toNumber(_cart_shipping));
  }
  $("#shipping").removeClass('invalid');
  $("#total, #m-total").html(_total_money_amount);
}

function validateCart() {
  return RegistriaShoppingCart.validateCart({
    success: function (data) {
      console.log("success = " + data);
      return data
    },
    error: function (data) {
      console.log("error = " + data);
      return data
    }
  })
}

// Util
function toMoney(value) {
  var _amount = Number(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return '$' + _amount;
}

function toNumber(value) {
  return Number(value.replace(/[$,]+/g, ""));
}

function formatPhone($el) {
  var number = $el.val()
  number = number.replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3");
  $el.val(number);
}

function actionStart() {
  $('.submitPayment').prop('disabled', true);
  $("#payment-back-btn").prop("disabled", true);
  $('.loading-overlay').css('opacity', '1');
}

function actionEnd() {
  $('.submitPayment').prop('disabled', false);
  $("#payment-back-btn").prop("disabled", false);
  $('.loading-overlay').css('opacity', '0');
}

function actionEndError() {
  $('.submitPayment').prop('disabled', true);
  $("#payment-back-btn").prop("disabled", true);
  $('.loading-overlay').css('opacity', '0');
}

function shippingEnabled() {
  return $("#hidden_shipping").length === 0 && $.siteConfiguration.enable_esp.enable_shipping_address
}

function billingSameAsShipping() {
  return $("#billing_same_as_shipping").is(":checked");
}

function isShippingSameAsBilling() {
  if ($('#shipping_email').val() == $('#billing_email').val() &&
    $('#shipping_first_name').val() == $('#billing_first_name').val() &&
    $('#shipping_last_name').val() == $('#billing_last_name').val() &&
    $('#shipping_phone').val() == $('#billing_phone').val() &&
    $('#shipping_address1').val() == $('#billing_address1').val() &&
    $('#shipping_address2').val() == $('#billing_address2').val() &&
    $('#shipping_city').val() == $('#billing_city').val() &&
    $('#shipping_state').val() == $('#billing_state').val() &&
    $('#shipping_zip').val() == $('#billing_zip').val() &&
    $('#shipping_country').val() == $('#billing_country').val()) {
    return true
  } else {
    return false
  }
}

function resetAddressForm(prefix) {
  $("input[id^=" + prefix + "_].registria_field").each(function () {
    var _originalValue = $(this).attr('data-original');
    $(this).val(_originalValue);
    $(this).focus();
  });
}

function redirectToDefault() {
  window.location.replace($.siteConfiguration.enable_esp.default_page);
}

function redirectToCart() {
  window.location.replace("/products_cart");
}

function hideAdditionalInformation() {
  if ($('#additional-details').find(':input').length === 0) {
    $('#additional-details').remove();
  }
}

function shippingAddressBlank() {
  if ($('#shipping_address1').val().length === 0 && $('#shipping_city').val().length === 0 &&
    $('#shipping_state').val().length === 0 && $('#shipping_zip').val().length === 0) {
    return true
  } else {
    return false
  }
}

function billingAddressBlank() {
  if ($('#billing_address1').val().length === 0 && $('#billing_city').val().length === 0 &&
    $('#billing_state').val().length === 0 && $('#billing_zip').val().length === 0) {
    return true
  } else {
    return false
  }
}

function taxErrorMessage() {
  if (shippingEnabled() === true && shippingAddressBlank() === true) {
    $("#tax").html($.polyglot.t('messages.shipping_address_missing'));
  } else if (billingAddressBlank === true) {
    $("#tax").html($.polyglot.t('messages.billing_address_missing'));
  } else {
    $("#tax").html($.polyglot.t('messages.tax_error'));
  }
}

function shippingErrorMessage() {
  if (shippingEnabled() === true && shippingAddressBlank() === true) {
    $("#shipping").html($.polyglot.t('messages.shipping_address_missing'));
    $("#shipping").addClass('invalid');
    return true
  } else if (isNaN(Number($(this).data("shippingPrice")))) {
    $("#shipping").html($.polyglot.t('messages.shipping_address_invalid'));
    $("#shipping").addClass('invalid');
    return true
  }

  return false
}

function resetShippingData() {
  $("#shipping-form input.shipping_method").each(function () {
    $(this).data("shippingPrice", "-");
    $(this).data("shippingMinEst", "-");
    $(this).data("shippingMaxEst", "-");
  })
}

// Setters
function setDefaultShipping() {
  var defaultShipping = $("input[data-shipping-method='" + espSettings.shippingMethod + "']")
  defaultShipping.trigger('click');
}

function setReferrer() {
  var referrer;

  if ($('#order_referrer').val().length > 0) {
    referrer = $("#order_guest").val() === 'true' ? $('#order_referrer').val() + "_guest" : $('#order_referrer').val()
    $('#order_referrer').val(referrer);
  } else if ($.cookie('ref_url') !== undefined && $.cookie('ref_url').length > 0) {
    referrer = $("#order_guest").val() === 'true' ? $.cookie('ref_url') + "_guest" : $.cookie('ref_url')
    $('#order_referrer').val(referrer);
  } else {
    referrer = $("#order_guest").val() === 'true' ? $.siteConfiguration.enable_esp.default_referrer + "_guest" : $.siteConfiguration.enable_esp.default_referrer
    $('#order_referrer').val(referrer);
  }
}

function setDataOriginal(prefix) {
  $("input[id^=" + prefix + "_]").each(function () {
    var _newValue = $(this).val();
    $(this).attr('data-original', _newValue);
  });
}

function setShippingAsBilling() {
  if (shippingEnabled()) { return }

  $('#shipping_email').val($('#billing_email').val());
  $('#shipping_first_name').val($('#billing_first_name').val());
  $('#shipping_last_name').val($('#billing_last_name').val());
  $('#shipping_phone').val($('#billing_phone').val());
  $('#shipping_address1').val($('#billing_address1').val());
  $('#shipping_address2').val($('#billing_address2').val());
  $('#shipping_address3').val($('#billing_address3').val());
  $('#shipping_city').val($('#billing_city').val());
  $('#shipping_state').val($('#billing_state').val());
  $('#shipping_zip').val($('#billing_zip').val());
  $('#shipping_country').val($('#billing_country').val());
  setDataOriginal("shipping");
}

function setBillingAsShipping() {
  if (!billingSameAsShipping()) { return }

  $("#billing_email").val($("#shipping_email").val());
  $("#billing_first_name").val($("#shipping_first_name").val());
  $("#billing_last_name").val($("#shipping_last_name").val());
  $("#billing_phone").val($("#shipping_phone").val());
  $("#billing_address1").val($("#shipping_address1").val());
  $("#billing_address2").val($("#shipping_address2").val());
  $("#billing_address3").val($("#shipping_address3").val());
  $("#billing_city").val($("#shipping_city").val());
  $("#billing_state").val($("#shipping_state").val());
  $("#billing_zip").val($("#shipping_zip").val());
  $("#billing_country").val($("#shipping_country").val());
  setDataOriginal("billing");
}

// Init Shopping Cart
function initCart() {
  var deferred = $.Deferred();

  RegistriaShoppingCart.init({
    success: function (data) {
      window.shoppingCart = data;

      if (window.shoppingCart.shopping_cart_items.length === 0) { redirectToDefault(); }

      $("#order_lines .lines").empty();
      _.forEach(data.shopping_cart_items, function (item) {
        var template = _.template($('#order-line-template').html());
        var nQty = item.quantity;
        var nPrice = parseFloat(item.price.replace("$", "")).toFixed(2);
        if (nQty > 1) {
          nPrice = nPrice * nQty;
        }
        $("#order_lines .lines").append(template({ name: item.name, price: '$'+nPrice, quantity: item.quantity, frequency: item.subscription_frequency }));
        $("[id^=product_option_][data-sku='" + item.sku + "']").prop('checked', true);
      });

      $('#subtotal').html(data.cart_sub_total);
      deferred.resolve(data);
    },
    error: function(data) {
      deferred.resolve(data);
    }
  })

  return deferred.promise();
}

function initAddresses() {
  setShippingAsBilling();
  setBillingAsShipping();

  if (!(isShippingSameAsBilling())) {
    $("#billing_same_as_shipping").prop('checked', false);
    $('#collapseShippingAddress').addClass("show");
  }
}

function upsertShippingAddress() {
  var deferred = $.Deferred();

  if ($("input[name^='order[shipping_address_'].registria_field.saattrs").length === 0) {
    deferred.resolve();
    return deferred.promise();
  }

  $.ajax({
    url: '/server_side_carts/update_cart_address',
    type: 'PUT',
    dataType: 'json',
    data: $("input[name^='order[shipping_address_'].registria_field.saattrs").serialize(),
    success: function (data) {
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function upsertBillingAddress() {
  var deferred = $.Deferred();

  if ($("input[name^='order[billing_address_'].registria_field.baattrs").length === 0) {
    deferred.resolve();
    return deferred.promise();
  }

  $.ajax({
    url: '/server_side_carts/update_cart_address',
    type: 'PUT',
    dataType: 'json',
    data: $("input[name^='order[billing_address_'].registria_field.baattrs").serialize(),
    success: function (data) {
      deferred.resolve(data);
    },
    error: function(error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function initRemovePromotions() {
  var deferred = $.Deferred();

  if (!($.siteConfiguration.enable_esp.enable_promotions)) {
    deferred.resolve();
    return deferred.promise();
  }

  RegistriaShoppingCart.removePromotion({
    success: function (data) {
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  });

  return deferred.promise();
}

function initProductPromotions() {
  if (isShippingMethodsSet() && !isFuji()) { return; }

  var deferred = $.Deferred();

  if (!(espSettings.autoPromotion && espSettings.autoPromotionCode.length > 0)) {
    deferred.resolve();
    return deferred.promise();
  }

  var promoCode = espSettings.autoPromotionCode;

  RegistriaShoppingCart.addOrderPromotion(promoCode, {
    success: function (data) {
      window.shoppingCart = data;
      applyOrderLinePromotion(data);
      $("#total, #m-total").html(data.cart_total);
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function initShippingPromotions() {
  if (isShippingMethodsSet() && !isFuji()) { return; }

  var deferred = $.Deferred();

  if (!(espSettings.autoShippingPromotion && espSettings.autoShippingPromotionCode.length > 0)) {
    deferred.resolve();
    return deferred.promise();
  }

  var promoCode = espSettings.autoShippingPromotionCode;

  RegistriaShoppingCart.addOrderPromotion(promoCode, {
    success: function (data) {
      window.shoppingCart = data;
      applyShippingPromotion(data);
      $("#total, #m-total").html(data.cart_total);
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function initMembershipPromotions() {
  if (isShippingMethodsSet() && !isFuji()) { return; }

  var deferred = $.Deferred();

  RegistriaShoppingCart.addMembershipBenefits({
    success: function (data) {
      window.shoppingCart = data;
      $("#total, #m-total").html(data.cart_total);
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function setShippingEstimates() {
  if (isShippingMethodsSet() && !isFuji()) { return; }
  var deferred = $.Deferred();

  if ($("#shipping-form").length < 1) {
    deferred.resolve();
    return deferred.promise();
  }

  $.ajax({
    url: '/server_side_carts/shipping_estimate',
    type: 'POST',
    dataType: 'json',
    data: {
      roundtrip: $("#shipping_type").data("roundtrip")
    },
    success: function (data) {
      for (var shippingType in data) {
        var $shippingMethod = $("input[data-shipping-method='" + shippingType + "']");
        var shipAmount = data[shippingType]["amount"];
        var shipMinEst = data[shippingType]["delivery_estimate"]["min"];
        var shipMaxEst = data[shippingType]["delivery_estimate"]["max"];
        var shipMinShort = dayjs(shipMinEst).format("ddd, MM/DD");
        var shipMaxShort = dayjs(shipMaxEst).format("ddd, MM/DD");

        $shippingMethod.data("shippingPrice", shipAmount);
        $shippingMethod.data("shippingMinEst", shipMinShort);
        $shippingMethod.data("shippingMaxEst", shipMaxShort);
        $shippingMethod.siblings("label").find('.shipping_price').html(toMoney(data[shippingType]["amount"]))
        $shippingMethod.siblings("label").find('.shipping_estimate').html('Est. Arrival: ' + shipMinShort + ' - ' + shipMaxShort)
      }
      setDefaultShipping();
      $(".submitPayment").prop("disabled", false);
      deferred.resolve(data);
    },
    error: function (error) {
      resetShippingData();
      shippingErrorMessage();
      $(".submitPayment").prop("disabled", true);
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function init() {
  actionStart();
  initAddresses();
  $.when(
    initCart(),
    upsertBillingAddress(),
    upsertShippingAddress()
  )
    .then(shippingMethodsUpdate)
    .then(setShippingEstimates)
    .then(initProductPromotions, initProductPromotions)
    .then(initShippingPromotions, initShippingPromotions)
    .then(initMembershipPromotions, initMembershipPromotions)
    .then(calculateTax, calculateTax)
    .then(function() {
      calculateShipping.call($(".shipping_method:checked"));
      actionEnd();
    })
    .fail(actionEndError)
}

// Promotions
function applyShippingPromotion(data) {
  if (data.promotion_type === "N") {
    $('#invalid-promo').css('display', 'block');
  } else {
    $('#invalid-promo').css('display', 'none');
    var codeDis = $("#promotion_code").val();
    if(codeDis.length > 0) {
      $('.promo-payment-drop').html('<p class="em2 promo-applied-msg" style="">Promo code &#34;' + codeDis + '&#34; applied</p>');
    }
    $('#shipping').html(data.cart_shipping_total);
    update_shipping_amounts(data.promotion_type);
    //sessionStorage.setItem("promo_primary", codeDis);
  }
}

function applyOrderLinePromotion(data) {
  if (data.cart_coupon_discount_total === "-") {
    if (toNumber(data.cart_total) !== 0) { $('#invalid-promo').css('display', 'block') }
    $('#discount').html("-$0.00");
  } else {
    $('#invalid-promo').css('display', 'none');
    $('#discount').html("-" + data.cart_coupon_discount_total);
    $('.payment-summary .discount').show();
    var codeDis = $("#promotion_code").val();
    if(codeDis.length > 0) {
      $('.promo-payment-drop').html('<p class="em2 promo-applied-msg" style="">Promo code &#34;' + codeDis + '&#34; applied</p>');
    }
    //sessionStorage.setItem("promo_primary", codeDis);
  }
}

function addOrderPromotion(promoCode) {
  var deferred = $.Deferred();

  if (promoCode == null) {
    deferred.resolve();
    return deferred.promise();
  }

  RegistriaShoppingCart.addOrderPromotion(promoCode, {
    success: function(data) {
      window.shoppingCart = data;
      if (data.promotion_type === "free_shipping" || data.promotion_type === "grouped_coupon") {
        applyShippingPromotion(data);
      } else {
        applyOrderLinePromotion(data);
      }

      $("#total, #m-total").html(data.cart_total);
      deferred.resolve(data);
    },
    error: function(error) {
      $('#invalid-promo').css('display', 'block');
      deferred.resolve(error);
    }
  });
  return deferred.promise();
}

function addPromotion(code) {
  $.when(addOrderPromotion(code))
    .then(function() {
      calculateTax();
    })
    .then(function() {
      calculateShipping.call($(".shipping_method:checked"));
      actionEnd();
    })
    .fail(actionEndError);
}

// Add or Update Cart
function emptyCart() {
  return RegistriaShoppingCart.emptyCart();
}

function addLine(line) {
  var deferred = $.Deferred();
  var registration = line.dataset.registration;
  var sku = line.dataset.sku;
  var quantity = line.dataset.quantity;

  RegistriaShoppingCart.addLine(sku, quantity, registration, {
    success: function (data) {
      window.shoppingCart = data;

      $("#order_lines .lines").empty();
      _.forEach(data.shopping_cart_items, function (item) {
        var template = _.template($('#order-line-template').html());
        $("#order_lines .lines").append(template({ name: item.name, price: item.price, quantity: item.quantity, frequency: item.subscription_frequency }));
      });

      $('#subtotal').html(data.cart_sub_total);
      deferred.resolve(data);
    },
    error: function(error) {
      deferred.resolve(error);
    }
  });

  return deferred.promise();
}

function removeLine(el, quantity) {
  var deferred = $.Deferred();
  var $el = el;
  var lineNumber = $el.data("line");

  RegistriaShoppingCart.removeLine(lineNumber, {
    success: function (data) {
      window.shoppingCart = data;
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function removeLines(skus) {
  var deferred = $.Deferred();

  RegistriaShoppingCart.removeLines(skus, {
    success: function (data) {
      window.shoppingCart = data;

      $("#order_lines .lines").empty();
      _.forEach(data.shopping_cart_items, function (item) {
        var template = _.template($('#order-line-template').html());
        $("#order_lines .lines").append(template({ name: item.name, price: item.price, quantity: item.quantity, frequency: item.subscription_frequency }));
      });

      $('#subtotal').html(data.cart_sub_total);
      deferred.resolve(data);
    },
    error: function (error) {
      deferred.resolve(error);
    }
  })

  return deferred.promise();
}

function addToCart(line) {
  $.when(emptyCart())
    .then(function() {
      return addLine(line)
    })
    .then(calculateTax)
    .then(actionEnd)
    .fail(actionEndError)
}

function outOfStockRemoveLines(skus) {
  $.when(removeLines(skus))
    .then(setShippingEstimates)
    .then(calculateTax, calculateTax)
    .then(function() {
      calculateShipping.call($(".shipping_method:checked"));
      actionEnd();
      $(".modal").modal("hide");
    })
    .fail(actionEndError)
}

// Update Address
function forShippingAddress() {
  setDataOriginal("shipping");
  setBillingAsShipping();
  $.when(
    upsertBillingAddress(),
    upsertShippingAddress()
  )
    .then(setShippingEstimates)
    .then(function() {
      return addOrderPromotion(window.shoppingCart.cart_free_shipping_promotion)
    })
    .then(calculateTax, calculateTax)
    .then(function() {
      calculateShipping.call($(".shipping_method:checked"));
      actionEnd();
    })
    .fail(actionEndError)
}

function forBillingAddress() {
  setDataOriginal("billing");
  setShippingAsBilling();
  if (!shippingEnabled()) {
    $.when(
      upsertBillingAddress(),
      upsertShippingAddress()
    )
      .then(setShippingEstimates)
      .then(calculateTax, calculateTax)
      .then(function() {
        calculateShipping.call($(".shipping_method:checked"));
        actionEnd();
      })
      .fail(actionEndError)
  } else {
    upsertBillingAddress().done(actionEnd).fail(actionEndError)
  }
}

function addressUpdater(type) {
  if (type === "shipping_address1" || type === "shipping_zip") { return forShippingAddress(); }
  if (type === "billing_address1" || type === "billing_zip") { return forBillingAddress(); }
}

var originalAutoFillCSC = autoFillCSC;
var autoFillCSC = function (obj, city, state, county, country, addr_id) {
  originalAutoFillCSC(obj, city, state, county, country);
  addressUpdater(addr_id);
}

// EventListeners
$('[id^=product_option_]').on('change', function() {
  var that = this;

  addToCart(that);
});

$("#payment-back-btn").on('click', function (event) {
  event.preventDefault();
  sessionStorage.removeItem('promo_primary');
  history.back(1);
});

$('#apply-promo').on('click', function (event) {
  event.preventDefault();

  var code = $("#promotion_code").val();

  if (code.length < 1) { return }

  encodedCode = encodeURI(code)

  addPromotion(encodedCode);
})

$('#billing_first_name, #billing_last_name, #shipping_first_name, #shipping_last_name').on('keydown', function (event) {
  if (this.selectionStart == 0 && event.keyCode >= 65 && event.keyCode <= 90 && !(event.shiftKey) && !(event.ctrlKey) && !(event.metaKey) && !(event.altKey)) {
    var $that = $(this);
    event.preventDefault();
    var char = String.fromCharCode(event.keyCode);
    $that.val(char + $that.val().slice(this.selectionEnd));
    this.setSelectionRange(1, 1);
  }
});

$('#shipping_email, #shipping_address2').on("change", function() {
  setBillingAsShipping();
})

$('#shipping_phone').on("change", function() {
  setBillingAsShipping();
})

$('#billing_email, #billing_address2').on("change", function() {
  setShippingAsBilling();
})

$('#billing_phone').on("change", function() {
  setShippingAsBilling();
})

$('.shipping_method').on('change', function () {
  if ($("#shipping-form").is(":visible") && $(this).valid()) {
    $('.shipping-method-section').find('.shipping-method-error label').remove()
  }

  calculateShipping.call(this);
})

$("#billing_same_as_shipping").on("change", function() {
  if ($(this).is(":checked")) {
    setBillingAsShipping();
  }
})

$("#payment_profile_id").on("change", function() {
  if ($(this).find(":selected").val() === "new_card") {
    $("#payment_form_details").collapse('show');
  } else {
    $("#payment_form_details").collapse('hide');
  }
})

$("#out-of-stock-confirm").on("click", function (event) {
  event.preventDefault();
  var action = $(this).data("action");
  var skus = $(this).data("skus");

  if (action == "reset") {
    RegistriaShoppingCart.resetCart({
      success: function () {
        redirectToCart();
      }
    })
  } else {
    outOfStockRemoveLines(skus);
  }
})

$("input.registria_field").on("change", function() {
  if ($("#registria_form").valid()) {
    actionEnd();
  }
})

$(".phone-format").on('change', function () {
  var number = $(this).val()
  number = number.replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3");
  $(this).val(number)
});

$('#registria_form').on('submit', function (event) {
  var $this = this;
  event.preventDefault();
  event.stopImmediatePropagation();
  $('.submitPayment').prop('disabled', true);
  $("#payment-back-btn").prop("disabled", true);

  validateCart()
    .then(function () {
      if ($('#registria_form').valid()) {
        $('.loading-overlay').css('opacity', '1');
        sessionStorage.removeItem('promo_primary');
        $this.submit();
      } else {
        actionEndError();
        return false;
      }
    }, function (response) {
      var data = response.responseJSON;
      var warnings = data.warnings;
      var action = data.action;
      var skus = data.skus
      var action_text = data.action == "reset" ? "RETURN TO CART" : "REMOVE UNAVAILABLE ITEM(S)"
      $("#out-of-stock-modal").data("outOfStock", warnings);
      $("#out-of-stock-confirm").data("action", action);
      $("#out-of-stock-confirm").data("skus", skus);
      $("#out-of-stock-confirm").text(action_text);
      $("#out-of-stock-list").empty();
      _.forEach(warnings, function (item) {
        var template = _.template($('#out-of-stock-item-template').html());
        $("#out-of-stock-list").append(template({ name: item.name, price: item.subtotal }));
      });
      $(document).off("mouseup");
      $("#out-of-stock-modal").modal({ backdrop: 'static', keyboard: false });
      return false;
    })
});

hideAdditionalInformation();

$(function () {
  (function fieldPrefills() {
    var getParams = function getParams() {
      var query = window.location.search.substring(1);
      var params = query.split('&');
      params = params.filter(Boolean);

      if (params.length === 0) { return []; }

      return params.map(function (param) {
        var split = param.split('=');
        return { key: split[0], value: decodeURIComponent(split[1].replace(/\+/g, " ")) };
      });
    };

    var popField = function popField(param) {
      if (param) $('#' + param.key).val(param.value);
    };

    getParams().forEach(function (param) {
      popField(param);
    });
  })();

  setReferrer();
  init();
});
$(function() {
  $.validator.addMethod('strictZip', function(value, element) {
    //var regEx = /^[0-9]{5}$/i;
    var regEx = /^(?!0{5})(\d{5})(?!-?0{4})(-?\d{4})?$/i;
    return regEx.test(value);
  }, $.polyglot.t('validations.invalid_zip'));

  $.validator.addMethod('strictCanadaZip', function(value, element) {
    var regEx = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
    return regEx.test(value);
  }, $.polyglot.t('validations.invalid_zip'));

  if ($(":input[name*='order[billing_address_attributes][email]']").length) {
    $(":input[name*='order[billing_address_attributes][email]']").rules("add", {
      regex: "^[A-Za-z0-9!%&'*+/=?^_`{|}~-]+(?:.[A-Za-z0-9!%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$".replace(new RegExp("\\.", "g"), "\\\."),
      required: $(":input[name*='order[billing_address_attributes][email]']")[0].required,
      messages: {
        regex: $.polyglot.t('validations.email')
      }
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][email]']").length) {
    $(":input[name*='order[shipping_address_attributes][email]']").rules("add", {
      regex: "^[A-Za-z0-9!%&'*+/=?^_`{|}~-]+(?:.[A-Za-z0-9!%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$".replace(new RegExp("\\.", "g"), "\\\."),
      required: $(":input[name*='order[shipping_address_attributes][email]']")[0].required,
      messages: {
        regex: $.polyglot.t('validations.email')
      }
    });
  }

  if ($(":input[name*='order[billing_address_attributes][first_name]']").length) {
    $(":input[name*='order[billing_address_attributes][first_name]']").rules("add", {
      regex: "^([a-zA-ZÀ-ÿ])([a-zA-ZÀ-ÿ0-9\\s\.',´‘’’’’’-]{0,40})$",
      required: true,
      messages: {
        regex: $.polyglot.t('validations.invalid')
      }
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][first_name]']").length) {
    $(":input[name*='order[shipping_address_attributes][first_name]']").rules("add", {
      regex: "^([a-zA-ZÀ-ÿ])([a-zA-ZÀ-ÿ0-9\\s\.',´‘’’’’’-]{0,40})$",
      required: true,
      messages: {
        regex: $.polyglot.t('validations.invalid')
      }
    });
  }

  if ($(":input[name*='order[billing_address_attributes][last_name]']").length) {
    $(":input[name*='order[billing_address_attributes][last_name]']").rules("add", {
      regex: "^([a-zA-ZÀ-ÿ])([a-zA-ZÀ-ÿ0-9\\s\.',´‘’’’’’-]{0,40})$",
      required: true,
      messages: {
        regex: $.polyglot.t('validations.invalid')
      }
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][last_name]']").length) {
    $(":input[name*='order[shipping_address_attributes][last_name]']").rules("add", {
      regex: "^([a-zA-ZÀ-ÿ])([a-zA-ZÀ-ÿ0-9\\s\.',´‘’’’’’-]{0,40})$",
      required: true,
      messages: {
        regex: $.polyglot.t('validations.invalid')
      }
    });
  }

  if ($(":input[name*='order[billing_address_attributes][address1]']").length) {
    $(":input[name*='order[billing_address_attributes][address1]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][address1]']").length) {
    $(":input[name*='order[shipping_address_attributes][address1]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[billing_address_attributes][city]']").length) {
    $(":input[name*='order[billing_address_attributes][city]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][city]']").length) {
    $(":input[name*='order[shipping_address_attributes][city]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[billing_address_attributes][state]']").length) {
    $(":input[name*='order[billing_address_attributes][state]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][state]']").length) {
    $(":input[name*='order[shipping_address_attributes][state]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[billing_address_attributes][zip]']").length) {
    $(":input[name*='order[billing_address_attributes][zip]']").rules("add", {
      required: true
    });
  }

  if ($(":input[name*='order[shipping_address_attributes][zip]']").length) {
    $(":input[name*='order[shipping_address_attributes][zip]']").rules("add", {
      required: true
    });
  }

  if (_.endsWith($.currentLocale, '-ca')) {
    if ($(":input[name*='order[billing_address_attributes][zip]']").length) {
      $(":input[name*='order[billing_address_attributes][zip]']").rules("add", {
        strictCanadaZip: true,
      });
    }
    if ($(":input[name*='order[shipping_address_attributes][zip]']").length) {
      $(":input[name*='order[shipping_address_attributes][zip]']").rules("add", {
        strictCanadaZip: true,
      });
    }
    var province_list = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'];
    if ($(":input[name*='order[billing_address_attributes][state]']").length) {
      $('#billing_state').frautoComplete(province_list.sort(), {
        listLimit: 5
      });
    }
    if ($(":input[name*='order[shipping_address_attributes][state]']").length) {
      $('#shipping_state').frautoComplete(province_list.sort(), {
        listLimit: 5
      });
    }
    $(".frauto-list").css('display','none');

  } else {
    if ($(":input[name*='order[billing_address_attributes][zip]']").length) {
      $(":input[name*='order[billing_address_attributes][zip]']").rules("add", {
        strictZip: true
      });
    }
    if ($(":input[name*='order[shipping_address_attributes][zip]']").length) {
      $(":input[name*='order[shipping_address_attributes][zip]']").rules("add", {
        strictZip: true
      });
    }
    var state_list = ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Virgin Islands', 'Armed Forces Americas', 'Armed Forces Europe', 'Armed Forces Pacific'];
    if ($(":input[name*='order[billing_address_attributes][state]']").length) {
      $('#billing_state').frautoComplete(state_list.sort(), {
        listLimit: 5
      });
    }
    if ($(":input[name*='order[shipping_address_attributes][state]']").length) {
      $('#shipping_state').frautoComplete(state_list.sort(), {
        listLimit: 5
      });
    }
    $(".frauto-list").css('display','none');
  }

  if ($('.shipping_method').length) {
    $('.shipping_method').each(function() {
      $(this).rules('add', { required: true });
    });
  }

  if ($('#credit_card_number').length) {
    $('#credit_card_number').rules('add', { creditcardtypes: { mastercard: true, visa: true, amex: true, discover: true } });
  }

  if ($('#credit_card_cvv').length) {
    $('#credit_card_cvv').rules('add', { cvv: { creditCard: "#credit_card_number" } });
  }

  if ($('#credit_card_year').length) {
    $('#credit_card_year').rules('add', { ccExpiration: { formMonth: "#credit_card_month", formYear: "#credit_card_year" } });
  }

  $('#credit_card_month').on('change', function () {
    $('#credit_card_year').valid();
  });

  // to Prohibit ESP Sales when Retailer = Sam's Club/Costco
  jQuery.validator.addMethod("prohibitretailer", function(val) {
    if(val.toUpperCase() == "COSTCO" || val.toUpperCase() == "SAM'S CLUB" ){
      return false;
    } else {
      return true;
    }
  }, "We’re sorry, your purchase is not eligible for a Protection plan.");

  if($("#purchased_at").length && $.siteConfiguration.site_name === "Sony" ){
    $("#purchased_at").rules("add", {
      prohibitretailer: true
    });
  }
  $('#purchased_at').on('change', function () {
    if(!$("#purchased_at").valid()){
      $("#purchased_at").parents().find('.form-group:first').css('margin-bottom','2rem');
    } else {
      $("#purchased_at").parents().find('.form-group:first').css('margin-bottom','1rem');
    }
  });
  if ($(".datepicker").length) {
    $('.datepicker').each(function() {
      var dp = $(this);
      var value = dp.data('value');
      dp.datepicker($.extend(true, {
          changeMonth: true,
          maxDate: new Date,
          yearRange: "-90:+00",
          changeYear: true
        },
        $.datepicker.regional["en-us"] || $.datepicker.regional['en-GB']));
        dp.datepicker('option', 'dateFormat', 'mm/dd/yy');
        if(value != null) {
          dp.datepicker('setDate', $.datepicker.parseDate('mm/dd/yy', value));
        }
    })
  }
})

$(document).ready(function() {
  renderMarkdown($('#footer-text'), $.polyglot.t('footer_text', $.interpolations));
  if ( _.get($.siteConfiguration,"enable_footer_links" ) ){
    renderMarkdown($('#footer_links'), $.polyglot.t('footer_links', $.interpolations));
  }
});
